const exported = {
    number: {
        EUR: {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        TRY: {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        PLN: {
            style: "currency",
            currency: "PLN",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        CNY: {
            style: "currency",
            currency: "CNY",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    }
};

export default exported;

export const { number } = exported;
